import OtherNames from './OtherNames';

export default OtherNames;
